import { parseAsInteger, useQueryState } from 'nuqs'
import { useMediaQuery } from 'usehooks-ts'
import { LINKS, SCENARIOS_PER_PAGE } from 'routes/constants'
import { ScenariosCard } from 'routes/components/Features/ScenarioCard'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import { ScenariosPagination } from 'routes/Scenarios/components/ScenariosPagination'
import clsx from 'clsx'
import classes from './ScenariosContent.module.scss'

export const ScenariosContent = ({
  total,
  loading,
  scenarios,
  onPageChange,
}: {
  total: number
  loading: boolean
  scenarios: ScenarioTemplateCompact[]
  onPageChange: (page: number) => void
}) => {
  const [page] = useQueryState('page', parseAsInteger.withDefault(1))

  const isMobile = useMediaQuery('(max-width: 575px)')
  const isDesktop = useMediaQuery('(min-width: 992px)')
  const siblingsValue = isMobile ? 0 : isDesktop ? 2 : 1

  return (
    <div className={classes.wrapper}>
      {loading ? (
        <ScenariosGridSkeleton />
      ) : (
        <>
          <ul className={classes.list}>
            {scenarios.map((scenario) => (
              <ScenariosContentCard key={scenario.key} scenario={scenario} />
            ))}
          </ul>
          <ScenariosPagination
            totalCount={total}
            siblingCount={siblingsValue}
            pageSize={SCENARIOS_PER_PAGE}
            currentPage={page}
            onPageChange={onPageChange}
          />
        </>
      )}
    </div>
  )
}

const ScenariosGridSkeleton = () => {
  const result = Array.from({ length: 10 }, (_, i) => (
    <li key={i} className={classes.item}>
      <div className={clsx(classes.card, classes.card__skeleton)}>
        <div className={classes.content} />
        <div className={classes.partners} />
      </div>
    </li>
  ))

  return <ul className={classes.list}>{result}</ul>
}

const ScenariosContentCard = ({
  scenario,
}: {
  scenario: ScenarioTemplateCompact
}) => {
  const scenarioPageLink = `${LINKS.SCENARIOS}/${scenario.key}`

  return (
    <li className={classes.item}>
      <ScenariosCard
        scenario={scenario}
        href={scenarioPageLink}
        className={classes.card}
      />
    </li>
  )
}
